import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import { AccountConnectionProviderId } from 'types/profile';
import { useExportDraft } from './hooks';

export interface ConnectToProviderDialogProps {
  releaseGuid: string;
  releaseExportGuid: string;
  providerId: AccountConnectionProviderId;
  isOpen: boolean;
  onClose: () => void;
  checkConnectionStatus: (
    providerId: AccountConnectionProviderId
  ) => Promise<string | undefined>;
  handleConnect: (providerId: AccountConnectionProviderId) => void;
}

export const ConnectToProviderDialog: React.FC<ConnectToProviderDialogProps> = ({
  releaseGuid,
  releaseExportGuid,
  providerId,
  isOpen,
  onClose,
  checkConnectionStatus,
  handleConnect,
}) => {
  const { completeReleaseExport } = useExportDraft(releaseGuid);

  const onClick = async () => {
    const renewedConnectionGuid = await checkConnectionStatus(providerId);

    if (!renewedConnectionGuid) {
      handleConnect(providerId);
    } else if (releaseExportGuid) {
      completeReleaseExport(
        { accountConnectionGuid: renewedConnectionGuid },
        providerId,
        releaseExportGuid
      );
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay />
      <ModalContent data-testid="dialog">
        <ModalHeader
          data-testid="dialog-title"
          title={`Connect to ${providerId}`}
        >
          Connect to {providerId}
        </ModalHeader>
        <ModalBody data-testid="dialog-text">
          <Text fontSize="md" pb={3}>
            You need to connect to {providerId} to export this Release.
          </Text>
          <Text fontSize="md">
            Connecting now will create a connection that can later be managed in
            Settings.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Stack spacing={2} direction="row">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" onClick={onClick}>
              Connect &amp; Export
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
